/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import ActionModel from 'cio/models/action';
import CampaignModel from 'cio/models/campaign';
import TemplateModel from 'cio/models/template';
import { DataActionConditionType } from 'cio/utils/campaigns/data-action';
import DataActionBodyAttributeRows from 'cio/app-models/data-action/body-attribute-rows';
import { action } from '@ember/object';

interface DataActionDefaultBodyEditorArgs {
  supportedConditionTypes: DataActionConditionType[];
  action: ActionModel;
  campaign: CampaignModel;
  template: TemplateModel;
  autocompleteValues: Partial<Record<DataActionConditionType, { label: string; value: string; path: string[] }[]>>;
  nameAutocompleteValues?: string[];
  showNameAutocompleteInput?: boolean;
  defaultEditorRows: DataActionBodyAttributeRows;
  updateHighlight: (highlight: any) => unknown;
  isLoadingAsyncAutocompleteValues: boolean;
  previewDidChange?: () => unknown;
  liquidFieldFocusIn: (fieldName: string, index?: number) => unknown;
  liquidFieldFocusOut: () => unknown;
  showLiquidTypeFallbackNotice?: boolean;
  hasReadOnlyPermission: boolean;
}

export default class DataActionDefaultBodyEditor extends Component<DataActionDefaultBodyEditorArgs> {
  get hasJSRows() {
    return this.args.defaultEditorRows.rows.some((row) => row.type === DataActionConditionType.JavaScript);
  }

  @action
  addRow() {
    this.args.defaultEditorRows.addRow();
  }

  @action
  removeRow(index: number) {
    this.args.defaultEditorRows.removeRow(index);
  }

  get conditionTypes() {
    let types = [...this.args.supportedConditionTypes];

    if (this.args.action.isCreateOrUpdatePersonAttributeAction) {
      types = [...types, DataActionConditionType.RemoveAttribute];
    }

    return types;
  }
}
